// Dashboard.tsx
import React from "react";

const Dashboard: React.FC = () => {
  return (
    <div className="h-screen w-full">
      <iframe
        src="https://superset.ussvision.com"
        title="Dashboard"
        width="100%"
        height="100%"
        style={{ border: "none" }}
      ></iframe>
    </div>
  );
};

export default Dashboard;
